export interface SaidasRelatorios {
  CZACDSCFAZ: string;
  CF2EMISSAO: string;
  CF2DOC: string;
  CF2SERIE: string;
  CF2CLIENTE: string;
  CNOMEFORCLI: string;
  CLOJAFORCLI: string;
  CD2ITEM: string;
  CD2COD: string;
  CB1DESC: string;
  ND2QUANT: number;
  CD2UM: string;
  ND2PRCVEN: number;
  ND2TOTAL: number;
}

export interface SaidasRelatoriosLista {
  items: Array<SaidasRelatorios>;
}

export const defaultSaidasRelatorios = (): SaidasRelatorios => {
  return {
    CZACDSCFAZ: '',
    CF2EMISSAO: '',
    CF2DOC: '',
    CF2SERIE: '',
    CF2CLIENTE: '',
    CNOMEFORCLI: '',
    CLOJAFORCLI: '',
    CD2ITEM: '',
    CD2COD: '',
    CB1DESC: '',
    ND2QUANT: 0,
    CD2UM: '',
    ND2PRCVEN: 0,
    ND2TOTAL: 0,
  }
}

export interface IFiltroSaidasFazendas {
  DEMISSAODE: Date | undefined;
  DEMISSAOATE: Date | undefined;
}

export const defaultIFiltroSaidasFazendas = (): IFiltroSaidasFazendas => {
  return {
    DEMISSAODE: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    DEMISSAOATE: new Date(),
  }
}
